import classNames from "classnames";
import type { MessageAuthor } from "PFTypes/propilot";
import type { ReactNode } from "react";

import css from "./generic_variant.module.scss";

export type VariantProps = {
  author: MessageAuthor;
  children: ReactNode;
};

const UserPointer = () => (
  <svg
    className={css.pointer}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M16 12.3987C3.5 12 0 3 0 -2V13.9485C4.76279 16.4281 12.6512 13.9485 16 12.3987Z"
      fill="var(--Accent-Color-primary-dark, #1531B8)"
    />
  </svg>
);

export const GenericVariant = ({ author, children }: VariantProps) => {
  const isUser = author === "user";
  const bubbleClass = classNames(css.bubble, isUser ? css.bubbleUser : css.bubbleAgent);

  return (
    <div className={bubbleClass} data-qa-id={`GenericVariant.${author}`}>
      {children}
      {isUser && <UserPointer />}
    </div>
  );
};
